import { ChangeEvent, useId } from "react";
import { Plus } from "@untitled-ui/icons-react";
import { Button } from "../ui/button";

interface UploadFileByButtonProps {
  onFileChange: (file: File | null) => void;
}

export const UploadFileByButton = ({ onFileChange }: UploadFileByButtonProps) => {
  const handleFileInput = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0] || null;
    onFileChange(selectedFile);
  };
	const inputId = useId();

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="inline-flex items-center gap-2 align-top">
        <div className="relative inline-block">
          <Button
            type="button"
            variant="outline"
            className="border-upload-button border-2 text-upload-button font-bold"
            onClick={() => document.getElementById(inputId)?.click()}
          >
            <Plus /> Charger
          </Button>
          <input
            id={inputId}
            type="file"
            onChange={handleFileInput}
            className="sr-only"
            aria-label="Upload file"
          />
        </div>
      </div>
    </div>
  );
};

export default UploadFileByButton;
